export default "__VITE_ASSET__DnIJyYJJ__"